import {AppLayout, Navbar, Sidebar} from "@project/design-system-web";

import {AppHeaderActions} from "./app-header-actions";
import {Breadcrumbs} from "./breadcrumbs";
import {useBreadcrumbs} from "./use-breadcrumbs";

/**
 * AppHeader — responsive shell toolbar.
 *
 * Desktop: sidebar trigger + breadcrumbs left, actions right.
 * Mobile: menu toggle left, actions right, breadcrumbs on second row.
 */
export function AppHeader() {
  const crumbs = useBreadcrumbs();
  const hasCrumbs = crumbs.length > 0;

  return (
    <div data-react-aria-top-layer="true">
      <Navbar size="sm" maxWidth="full" position="static" shouldBlockScroll={false}>
        <Navbar.Header>
          <AppLayout.MenuToggle />
          <Sidebar.Trigger />

          <div className="hidden min-w-0 flex-1 overflow-hidden md:block">
            {hasCrumbs && <Breadcrumbs placement="desktop" />}
          </div>

          <Navbar.Spacer className="md:hidden" />

          <AppHeaderActions />
        </Navbar.Header>
      </Navbar>

      {hasCrumbs && (
        <div className="border-border min-w-0 overflow-hidden border-t px-3 py-2 md:hidden">
          <Breadcrumbs placement="mobile" />
        </div>
      )}
    </div>
  );
}
